/**
 * @generated SignedSource<<a00d79ea0d52ad0083a5c0bca31d41b0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SpotlightTourContainer$data = {
  readonly isNaturalLanguageSpotlightTourEnabled: boolean | null | undefined;
  readonly " $fragmentType": "SpotlightTourContainer";
};
export type SpotlightTourContainer$key = {
  readonly " $data"?: SpotlightTourContainer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SpotlightTourContainer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "SpotlightTourContainer",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isNaturalLanguageSpotlightTourEnabled"
    }
  ],
  "type": "JiraUserPreferences"
};

(node as any).hash = "38c00e4fe4b732ccd771d9939412a015";

export default node;
